// extracted by mini-css-extract-plugin
export default {"GitHubAvatar_0":"ValueIcon-module__GitHubAvatar_0--SPpxy","Box_0":"ValueIcon-module__Box_0--wnfjP"};